import { HelpVideoChildComponent } from '../helpVideoChildComponent';

const WorkspaceAdmin = () => {
  const topicList = [{ id: '840830400', label: 'How to send Invitation to user on Wisestep' }];
  return <HelpVideoChildComponent isFromSettings={true} topicArrayList={topicList} />;
};

export default WorkspaceAdmin;
